import TargetsProduct from './TargetsProductModalPage';

export default TargetsProduct;
